import styled from 'styled-components';

export const ChartBar = styled.div<{ height: number }>`
  flex: 1;
  margin-right: 1%;
  background: #ebeef5;
  height: ${({ height }) => height}px;
`;

export const MockChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 15px;
  align-items: flex-end;
  ${ChartBar}:last-child {
    margin: 0;
  }
`;
